import { render, staticRenderFns } from "./EventoTimeline.vue?vue&type=template&id=3158bc68&scoped=true"
import script from "./EventoTimeline.vue?vue&type=script&lang=js"
export * from "./EventoTimeline.vue?vue&type=script&lang=js"
import style0 from "./EventoTimeline.vue?vue&type=style&index=0&id=3158bc68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3158bc68",
  null
  
)

export default component.exports